import React from 'react';

export default function Space(props) {
    return (<div className={props.className ? props.className : ""}
                 style={{height: props.height ? props.height : "0.5em"}}/>)
}